
<div class="form-field" [ngClass]="{'border-green': getIsInputCompleted(),'is-incomplete': isIncomplete}">
    
    <input  ondrop="return false;" autocomplete="off"
    (keypress)="validateInputText($event)" (change)="select($event)" 
    type="text" placeholder="{{initialPlaceHolder}}"  value="{{getValue()}}"
    class="form-control no-background-border margin" aria-label="title">
</div>
